import React from 'react';
import { usePlanFeature } from '@api/hooks/useSubscription';

interface PlanGateProps {
  feature: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Renders children only if the current tenant's plan includes the specified feature.
 * Shows optional fallback content if the feature is not available.
 */
export default function PlanGate({ feature, children, fallback = null }: PlanGateProps) {
  const hasFeature = usePlanFeature(feature);

  if (!hasFeature) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
